export default "__VITE_ASSET__CwhURuZL__"